import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import { breadcrumbJsonLd } from '../seo/structuredData';
import { useI18n } from '../i18n/I18nContext';
import './AboutMe.css';

function AboutMe() {
  const { lang, copy } = useI18n();
  const home = lang === 'en' ? '/en' : '/';
  const insights = lang === 'en' ? '/en/insights' : '/impulse';

  return (
    <div className="michaela-about-me-page">
      <Seo
        page="about"
        jsonLd={breadcrumbJsonLd([
          { name: lang === 'en' ? 'Home' : 'Home', path: home },
          { name: copy.about.crumb, path: lang === 'en' ? '/en/about' : '/ueber-mich' },
        ])}
      />
      <Header />
      
      <section className="michaela-about-me-main">
        <div className="michaela-about-me-container">
          <div className="michaela-about-me-content">
            <h1 className="michaela-about-me-label">{copy.about.label}</h1>
            
            <div className="michaela-about-me-intro">
              <p>{copy.about.p1}</p>
            </div>

            <div className="michaela-about-me-bio">
              <p>{copy.about.p2}</p>
              <p>{copy.about.p3}</p>
              <p>{copy.about.p4}</p>
            </div>

            <p className="michaela-about-me-impulse-link-wrap">
              <Link to={insights} className="michaela-about-me-impulse-link">
                {copy.about.link}
              </Link>
            </p>
          </div>

          <div className="michaela-about-me-image-wrapper">
            <img
              src="/img/michaela_ueber_mich.png"
              alt={copy.about.photoAlt}
              className="michaela-about-me-photo"
            />
          </div>
        </div>
      </section>

      <Footer showContactForm={false} />
    </div>
  );
}

export default AboutMe;
